var _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "var(--ci-primary-color, #000000)",
    points: "272 227.616 272 121.388 240 121.388 240 227.617 141.377 167.935 138.946 171.952 138.946 203.867 225.096 256 138.946 308.133 138.946 340.048 141.377 344.065 240 284.383 240 390.612 272 390.612 272 284.384 370.623 344.065 373.054 340.049 373.054 308.134 286.903 256 373.054 203.866 373.054 171.951 370.623 167.935 272 227.616",
    className: "ci-primary"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--ci-primary-color, #000000)",
    d: "M425.857,87.379A239.365,239.365,0,0,0,87.344,425.892,239.365,239.365,0,0,0,425.857,87.379ZM256.6,464C142.259,464,49.236,370.977,49.236,256.636S142.259,49.271,256.6,49.271s207.365,93.023,207.365,207.365S370.942,464,256.6,464Z",
    className: "ci-primary"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/center.1bfe738039a146c7ceac2fcd6f602f4f.svg";
export { ForwardRef as ReactComponent };